import React from "react";

export default function RadioThemed({ isChecked = false, themeColor = '#4f7c9c' }) {
    return (
        <div
            style={{
                width: '22px',
                height: '22px',
                borderRadius: '50%',
                background:'white',
                border: `3px solid ${themeColor}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
            }}
        >
            {isChecked && (
                <div
                    style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: themeColor,
                    }}
                />
            )}
        </div>
    );
}
